import { render } from "./LabelSizesButton.vue?vue&type=template&id=e630a51e&scoped=true&ts=true"
import script from "./LabelSizesButton.vue?vue&type=script&lang=ts"
export * from "./LabelSizesButton.vue?vue&type=script&lang=ts"

import "./LabelSizesButton.vue?vue&type=style&index=0&id=e630a51e&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e630a51e"]])

export default __exports__